// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/components/Wordmark.tsx
// PLAN2 WP09 (text), rebuilt by PLAN11 WP11-07 (D11-26): the Mindario wordmark as an SVG picture of the name. The accessible name is
// t(common.product-name) — the logo is not copy, but its label is (RL-03). `size` is the old text size and now sets the height
// (18 → 18 px). `tracking` is accepted and ignored so call sites keep compiling. `tone` picks the letter colour by token
// (`auto` follows the theme; `on-dark` and `on-light` fix it for a surface of known colour). A link when href is given (DesignLink, C-105).
import { S } from "../strings.js";
import { useDesignI18n } from "../i18n.js";
import { cx } from "../cx.js";
import { DESIGN_TESTIDS as T } from "../testids.js";
import { LogoSvg, type LogoTone } from "../brand/Logo.js";
import { WORDMARK } from "../brand/paths.js";
import { DesignLink } from "./DesignLink.js";

export type WordmarkSize = 18 | 20 | 22 | 24 | 28 | 32;
const HEIGHT: Record<WordmarkSize, string> = { 18: "h-4.5", 20: "h-5", 22: "h-5.5", 24: "h-6", 28: "h-7", 32: "h-8" };

export interface WordmarkProps {
  size?: WordmarkSize;
  /** Ignored: kept so PLAN2–PLAN10 call sites compile. */
  tracking?: "surface" | "site" | "rail";
  tone?: LogoTone;
  href?: string;
  className?: string;
  "data-testid"?: string;
}

export function Wordmark({ size = 20, tone = "auto", href, className, "data-testid": testId }: WordmarkProps) {
  const { t } = useDesignI18n();
  const name = t(S.productName);
  const svg = <LogoSvg geometry={WORDMARK} label={name} tone={tone} className={cx(HEIGHT[size], href ? undefined : className)} data-testid={href ? undefined : testId ?? T.wordmark.root} />;
  return href ? (
    <DesignLink href={href} className={cx("inline-block no-underline", className)} data-testid={testId ?? T.wordmark.root}>{svg}</DesignLink>
  ) : svg;
}
